<template>
  <div class="default-header">
    <div class="header-left">
      <div class="company-info">
        <div class="company-logo-wrapper">
          <img class="company-logo" :src="headerCompanyLogo"/>
        </div>
      </div>
    </div>
    <div class="navigation">
      <div class="navigation-item">
        <a class="link" href="/jobseekers/">{{ $t('login.common.title.candidateIndexPage') }}</a>
      </div>
      <div class="navigation-item">
        <a class="link" href="/">{{ $t('login.common.title.indexPage') }}</a>
      </div>
      <div class="navigation-item">
        <a class="link" href="/?intelligence=1">{{ $t('login.common.title.intelligencePage') }}</a>
      </div>
      <div class="navigation-item">
        <div v-if="isLogin" class="navigation user">
          <HeaderUserMenu light-theme showDropDownArrow :isPreview="isPreview" :isMSDCompany="isMSDCompany" class="user-menu-dropdown">
          </HeaderUserMenu>
        </div>
        <div v-else class="login-btn" @click="handleLogin">{{ $t('common.btn.signIn') }}</div>
      </div>
      <div class="navigation-item">
        <span class="language" @click="handleLanguageBtnClick">{{ anotherLanguageName }}</span>
      </div>
      <div class="navigation-item hotline">
        <i class="iconfont iconTelephone hotline-icon"></i>
        <div class="dropdown-container">
          <div class="hotline-list">
            <div class="detail-line">
              <span class="line-label">{{ $t('admin.layout.header.hotline.cnUser') }}</span>
              <span class="line-content phone">400-990-3308</span>
            </div>
            <div class="detail-line">
              <span class="line-label">{{ $t('admin.layout.header.hotline.allUser') }}</span>
              <span class="line-content email link">service@ajinga.com</span>
            </div>
          </div>
          <div class="dropdown-padding"></div>
          <div class="dropdown-arrow"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { ACCOUNT_TYPE } from '@/constant/common'
import { isEn, switchLanguageWithZhAndEn } from '@/i18n'
import { mapActions, mapGetters } from 'vuex'
import HeaderUserMenu from '@/components/layout/header/headerUserMenu.vue'

export default {
  components: {
    HeaderUserMenu
  },
  data () {
    return {
      showChristmasLogo: false,
      showNewYearLogo: false
    }
  },
  computed: {
    isLogin () {
      const account = this.getCurrentAccount()
      return Boolean(account && account.id)
    },
    isMSDCompany () {
      return false
    },
    headerCompanyLogo () {
      return require('@/assets/image/ajinga_logo_black.png')
    },
    accountTypeLabel () {
      const key = _.findKey(ACCOUNT_TYPE, (val) => val === this.accountType)
      if (key) {
        return this.$t(`login.common.accountType.${key}`)
      }
      return ''
    },
    accountTypeList () {
      if (this.isPc) {
        return ACCOUNT_TYPE
      }
      const list = {}
      _.forEach(ACCOUNT_TYPE, (val, key) => {
        if (val === ACCOUNT_TYPE.AGENCY) {
          return
        }
        list[key] = val
      })
      return list
    },
    anotherLanguageName () {
      return isEn() ? '中文' : 'English'
    }
  },
  created () {

  },
  methods: {
    ...mapActions('common', ['changeLanguage']),
    ...mapGetters('account', ['getCurrentAccount']),
    handleLanguageBtnClick () {
      switchLanguageWithZhAndEn()
      this.changeLanguage(isEn() ? 'en' : 'zh-cn')
    },
    handleLogin () {
      this.$router.push({
        path: '/passport/candidate/login',
        query: this.$route.query
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.default-header {
  height: 124px;
  line-height: 124px;
  padding: 0 40px;
  background-color: #fff;

  &::after {
    content: '';
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
  }

  .header-left {
    float: left;
    height: 100%;
    display: flex;
    align-items: center;

    .navigation-link {

      .link {
        color: #606266;
        margin-right: 20px;

        &:hover {
          color: #0096cc;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .navigation {
    float: right;
    display: flex;
    height: 100%;
    font-size: 14px;
    align-items: center;

    .navigation-item {
      padding: 0 20px 0 21px;
      line-height: 32px;
      position: relative;

      &::before {
        content: '';
        display: block;
        width: 1px;
        position: absolute;
        left: 0;
        top: 4px;
        bottom: 4px;
        background: #dcdfe6;
      }

      &:first-child {
        padding-left: 0;

        &::before {
          display: none;
        }
      }

      &:last-child {
        padding-right: 0;
      }

      .link {
        color: #606266;

        &:hover {
          color: #0096cc;
        }
      }

      .language {
        cursor: pointer;
        color: #0096cc;

        &:hover {
          color: #00aaff;
        }
      }

      .login-btn {
        border: 1px solid #0096cc;
        line-height: 30px;
        width: 82px;
        text-align: center;
        color: #0096cc;
        cursor: pointer;

        &:hover {
          color: #00aaff;
          border-color: #00aaff;
        }
      }

      .user {
        .user-menu-dropdown {
          height: 32px;
          line-height: 32px;
          top: 0;
        }
      }

      &.hotline {
        position: relative;
        top: 2px;

        .hotline-icon {
          font-size: 24px;
          cursor: pointer;
          color: #939393;

          &:hover {
            ~ .dropdown-container {
              display: block;
            }
          }
        }

        .hotline-list {
          .detail-line {
            height: 22px;
            line-height: 22px;
            word-break: keep-all;
            white-space: nowrap;

            .line-label {
              display: inline-block;
              width: 85px;
              color: #333;
            }

            .line-content {
              margin-left: 10px;
              font-size: 14px;

              &.phone {
                color: #ff6633;
              }

              &.email{
                text-decoration: underline;
              }
            }
          }
        }

        .dropdown-container {
          display: none;
          margin-top: 20px;
          padding: 10px 15px;
          border: 1px solid #aaa;
          border-radius: 10px;
          background: #fff;
          cursor: pointer;
          position: absolute;
          top: 100%;
          right: -18px;
          z-index: 10;

          &:hover {
            display: block;
          }

          .dropdown-arrow {
            width: 22px;
            height: 15px;
            background: url($baseDomain + 'static/image/list_assets.png?t=5') no-repeat -20px -142px;
            position: absolute;
            top: -13px;
            right: 18px;
          }

          .dropdown-padding {
            width: 35px;
            height: 30px;
            position: absolute;
            top: -30px;
            right: 14px;
          }
        }
      }
    }
  }
}

.company-info {
  &.has-left-navigation {
    margin-right: 20px;
  }

  .company-logo-wrapper {
    display: inline-block;
    width: 165px;
    overflow: hidden;
    vertical-align: middle;

    .company-logo {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .company-name {
    display: inline-block;
    max-width: 250px;
    margin-left: 15px;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
  }
}
</style>
